import { defineComponent, h, onMounted, onUnmounted, ref, type PropType, type VNode } from 'vue';

export default defineComponent({
	props: {
		element: {
			type: Object as PropType<HTMLElement>,
			required: true,
		},
	},
	setup: (props): (() => VNode) => {
		const container = ref<HTMLElement | null>(null);

		onMounted(() => container.value?.appendChild(props.element));
		onUnmounted(() => props.element.remove());

		return () => h('div', { ref: container });
	},
});